(function () {
  'use strict';

  angular
    .module('app.segmentationReportSegment')
    .controller('segmentationReportSegmentCtrl', segmentationReportSegmentCtrl);

  segmentationReportSegmentCtrl.$inject = ['measureService', 'segmentationReportSegmentService', '$scope', '$rootScope', '$modal'];
  function segmentationReportSegmentCtrl(measureService, segmentationReportSegmentService, $scope, $rootScope, $modal) {

    var pieChartConfig = {
      options: {
        chart: {
          type: 'pie',
          zoomType: 'x',
          backgroundColor: null,
          marginTop: 16
        },
        tooltip: {
          enabled: false
        },
        plotOptions: {
          pie: {
            allowPointSelect: false,
            cursor: 'pointer',
            dataLabels: {
              enabled: false
            },
            showInLegend: false
          }
        },
        credits: {
          enabled: false
        }
      },
      series: [{
        size: '80%',
        innerSize: '90%'
      }],
      title: {
        text: '',
        style: {
          fontSize: '16px',
          color: '#4B5567',
          fontFamily: 'ProximaNovaSemibold'
        }
      },
      xAxis: {
        type: 'datetime',
        title: {
          text: 'Date'
        }
      },
      noData: 'Pending Data...',
      loading: true
    };

    var pieChartConfigForPrint = {
      options: {
        chart: {
          type: 'pie',
          zoomType: 'x',
          backgroundColor: null,
          marginTop: 45
        },
        tooltip: {
          enabled: false
        },
        plotOptions: {
          pie: {
            allowPointSelect: false,
            cursor: 'pointer',
            dataLabels: {
              enabled: false
            },
            showInLegend: false
          }
        },
        credits: {
          enabled: false
        }
      },
      series: [{
        size: '120%',
        innerSize: '90%'
      }],
      title: {
        text: '',
        style: {
          fontSize: '20px',
          color: '#4B5567',
          fontFamily: 'ProximaNovaSemibold'
        }
      },
      xAxis: {
        type: 'datetime',
        title: {
          text: 'Date'
        }
      },
      noData: 'Pending Data...',
      loading: true
    };

    $scope.$on('refreshDashboard', function(event, args) {
      getDataSegmentationReportSegment();
    });

    function generateSegmentsData(segments) {
      $scope.segments = [];

      var segment = {};
      var segmentList = [];

        if($scope.selectedTopic.length > 0)
        {
          _.forEach(segments, function (item) {
            _.forEach($scope.selectedTopic, function(topic) {
                if(item.id == topic.topic_id){
                  // chart
                  segment.pieChartConfig = angular.copy(pieChartConfig);
                  segment.pieChartConfig.series[0].name = item.name;
                  segment.pieChartConfig.title.text = item.name;
                  segment.pieChartConfig.series[0].data = [{color: '#FF6C9D', y: item.valuePieChart}, {color: '#EEF2F4', y: (1-item.valuePieChart)}];
                  // for print chart
                  segment.pieChartConfigForPrint = angular.copy(pieChartConfigForPrint);
                  segment.pieChartConfigForPrint.series[0].name = item.name;
                  segment.pieChartConfigForPrint.title.text = item.name;
                  segment.pieChartConfigForPrint.series[0].data = [{color: '#FF6C9D', y: item.valuePieChart}, {color: '#EEF2F4', y: (1-item.valuePieChart)}];
                  // name
                  segment.name = item.name;
                  segment.contentPieChart = _.get(item, 'contentPieChart');
                  segment.contentPieChart.value = segment.contentPieChart.value;
                  segmentList.push(segment);
                }
                segment = {};
            })
          });
        }
        else
        {
            for(var i=0; i< $scope.segmentRemoveList.length; i++)
            {
                for(var j = segments.length - 1; j >= 0; j--)
                {
                    if($scope.segmentRemoveList[i].name == segments[j].name)
                    {
                        segments.splice(j, 1);
                    }
                }
            }

            _.forEach(segments, function (item) {
                if(item.name != "NA"){
                  // chart
                  segment.pieChartConfig = angular.copy(pieChartConfig);
                  segment.pieChartConfig.series[0].name = item.name;
                  segment.pieChartConfig.title.text = item.name;
                  segment.pieChartConfig.series[0].data = [{color: '#FF6C9D', y: item.valuePieChart}, {color: '#EEF2F4', y: (1-item.valuePieChart)}];
                  // for print chart
                  segment.pieChartConfigForPrint = angular.copy(pieChartConfigForPrint);
                  segment.pieChartConfigForPrint.series[0].name = item.name;
                  segment.pieChartConfigForPrint.title.text = item.name;
                  segment.pieChartConfigForPrint.series[0].data = [{color: '#FF6C9D', y: item.valuePieChart}, {color: '#EEF2F4', y: (1-item.valuePieChart)}];
                  // name
                  segment.name = item.name;
                  segment.contentPieChart = _.get(item, 'contentPieChart');
                  segment.contentPieChart.value = segment.contentPieChart.value;
                  segmentList.push(segment);
                  if(item.id != null)
                  {
                      $scope.selectedTopic.push({
                          topic_id: item.id,
                          topic_name: item.name
                      });
                  }
                }
                segment = {};
            });
        }

      // divide layout
      var i = 0;
      var layout = [];
      _.forEach(segmentList, function (item) {
        i++;
        if (i % 4 === 0) {
          layout.push(item);
          $scope.segments.push(layout);
          layout = [];
          i = 0;
        } else {
          layout.push(item);
        }
        
      });
      if (layout.length != 0) {
        $scope.segments.push(layout);
      }
      // $scope.$broadcast('highchartsng.reflow');
    }

    function getDataSegmentationReportSegment() {
      var params = $rootScope.saveParams;
      if(params == null || (params.mention == 0 && params.blog_id == 0 && params.project_id == 0 && params.channel == 0 && params.influencerGroup == 0)) {
        return;
      }
      params.date = $rootScope.selectedPeriod.period ? $rootScope.selectedPeriod.period.value : 7;

      getSegmentTopicData(params);
      $scope.selectedTopic = [];
    }

    function getSegmentTopicData(params){
      segmentationReportSegmentService.getSegmentTopicData(params, false)
        .then(function(response){
            $scope.segmentRemoveList = response.data.segmentRemoveList;
            generateSegmentsData(response.data.segments);
        })
        .catch(function(message){
           $scope.segments = [];
        })
        .finally(function(){
          $rootScope.$broadcast('sectionLoaded');
        })            
    }
    
    // first initiating
    getDataSegmentationReportSegment();


    $scope.showSettingSegmentReport = function()
    {
        var topicSettingModalInstance = $modal.open({
            scope: $scope,
            templateUrl: 'app/measure/segmentationReport/segmentationReportSegment/topicSettingReportSegment/topicSettingReportSegment.html?app_v=deployDate',
            controller: 'topicSettingReportSegmentCtrl',
            resolve: {
                selectedTopic: function () {
                    return $scope.selectedTopic;
                }
            }
        });

        $scope.topicSettingModalInstance = topicSettingModalInstance;
        topicSettingModalInstance.result.then(function(selectedTopic) {
            $scope.selectedTopic = selectedTopic;
            var params = $rootScope.saveParams;
            getSegmentTopicData(params);
        }, function(tempSelectedTopic) {
            if(tempSelectedTopic != "backdrop click" && tempSelectedTopic != "escape key press"){
                $scope.selectedTopic = tempSelectedTopic;
            }
        });
    }

  }
})();